import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox} from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';

export class AttrForm extends Component
{
   constructor(props) {
		super(props);
		console.log('AttrForm:props='+JSON.stringify(props));
		this.state={attrs:this.props.attrs};
		this.onValChange = this.onValChange.bind(this);
    }
    componentDidMount()
    {
    }
    onValChange(e)
	{
		var attrs = this.state.attrs;
		attrs[e.target.id]=e.target.value;
		this.setState({attrs:attrs});
        var rec = {...attrs,id:this.props.personUdfId};
		this.props.onChange(rec);
	}
    onCheckboxChange=(e)=>{
		var attrs = this.state.attrs;
		attrs[e.target.id]=e.target.checked;
		this.setState({attrs:attrs});
		this.props.onChange(this.state.attrs);        
    }
    createField=(udf)=>{
        if(udf.fieldType == 'STRING')
        {
            return(
            <div className="field grid col-12 xl:col-8 mb-0">
                <label htmlFor={udf.name} className="col-12 md:col-2 md:mb-0">{udf.label}</label>
                <div className="col-12 md:col-10">
                    <InputText id={udf.name} className="w-full" value={this.state.attrs[udf.name]} type="text" onChange={this.onValChange}/>
                </div>
            </div>
            );
        }
        else if(udf.fieldType == 'INT')
        {
            return(
            <div className="field grid col-12">
                <label htmlFor={udf.name} className="col-12 md:col-2 md:mb-0">{udf.label}</label>
                <div className="col-12 md:col-10">
                    <InputNumber id={udf.name} className="w-full" value={this.state.attrs[udf.name]} mode="decimal" maxFractionDigits="0" onValueChange={this.onValChange}/>
                </div>
            </div>
            );
        }        
        else if(udf.fieldType == 'DEC')
        {
            return(
            <div className="field grid col-12">
                <label htmlFor={udf.name} className="col-12 md:col-2 md:mb-0">{udf.label}</label>
                <div className="col-12 md:col-10">
                    <InputNumber id={udf.name} className="w-full" value={this.state.attrs[udf.name]} mode="decimal" maxFractionDigits="6" onValueChange={this.onValChange}/>
                </div>
            </div>
            );
        }        
        else if(udf.fieldType == 'BOOL')
        {
            return(
            <div className="field-checkbox grid col-12">
                <input type="checkbox" id={udf.name} checked={this.state.attrs[udf.name]} onChange={this.onCheckboxChange}></input>
                <label htmlFor={udf.name} class="col-12 md:col-2 md:mb-0">{udf.label}</label>
            </div>
            );
        }        
        else if(udf.fieldType == 'DATE')
        {
            return(
            <div className="field grid col-12">
                <label htmlFor={udf.name} class="col-12 md:col-2 md:mb-0">{udf.label}</label>
                <div className="col-12 md:col-10">
                    <InputText id={udf.name} className="w-full" value={this.state.attrs[udf.name]} type="date" onChange={this.onValChange}/>
                </div>
            </div>
            );
        }        
        else if(udf.fieldType == 'LIST')
        {
            return(
            <div className="field grid col-12 xl:col-8 mb-0">
                <label htmlFor={udf.name} className="col-12 md:col-2 md:mb-0">{udf.label}</label>
                <div className="col-12 md:col-10">
                    <Dropdown id={udf.name} className="w-full" value={this.state.attrs[udf.name]} onChange={this.onValChange} options={udf.options}/>
                </div>
            </div>
            );
        }
    }
	render()
	{
		return(
		<div className='grid m-0 mt-4'>
            {this.props.udfs.map((udf,index)=>{
                return this.createField(udf);
            })}
		</div>
		);
	}
}
export function attrFormField(udf)
{
    if(udf.fieldType == 'STRING')
        return({id:udf.name,ftype:"text",field:udf.name,label:udf.label});
    else if(udf.fieldType == 'INT')
        return({id:udf.name,ftype:"number",field:udf.name,label:udf.label});
    else if(udf.fieldType == 'DEC')
        return({id:udf.name,ftype:"number",field:udf.name,label:udf.label});
    else if(udf.fieldType == 'LIST')
        return({id:udf.name,ftype:"dropdown",field:udf.name,label:udf.label,options:udf.options});
    else if(udf.fieldType == 'BOOL')
        return({id:udf.name,ftype:"checkbox",field:udf.name,label:udf.label});
    else if(udf.fieldType == 'DATE')
        return({id:udf.name,ftype:"date",field:udf.name,label:udf.label});

    return null;
}
export default AttrForm;